module.exports = __webpack_public_path__ + "static/ic-vlatko-698426ae9970d6f2bd076a562fbe4fd9.png";